import { Component } from 'preact';
import PropTypes from 'prop-types';

// Components
import InputText from './InputText';
import { getAge } from '../../../utilities/common';
import { getDateOfBirth } from '../../../utilities/form/formValidators';

class CprText extends Component {
  render() {
    const newProps = this.props;
    newProps.type = 'tel';
    newProps.updateExtraFields = (id, value, setFieldValue) => {
      const dob = getDateOfBirth(value);
      setFieldValue(`${id}-dob`, dob);
      setFieldValue(`${id}-age`, getAge(dob));
      setFieldValue('age', getAge(dob));
      setFieldValue(`${id}01`, value.substring(0, 6));
    };

    // eslint-disable-next-line no-unused-vars
    newProps.updateValue = (value, values) => {
      const regex = new RegExp('(.*?)(([0-9]{1,6})[-]?([0-9]{0,4}))?(.*)');
      let newValue = value.replace(regex, '$2');

      if (regex.test(value)) {
        if (value.length > 6) {
          newValue = value.replace(regex, '$3-$4');
        }
      }
      return newValue;
    };

    return (
      <InputText
        {...newProps}
      />
    );
  }
}

export default CprText;

CprText.defaultProps = {
  required: false,
  placeholder: null,
  desc: null,
  label: null,
  maxLength: null,
  endFocus: null,
  mobileColumns: null,
  isLoading: null,
  formValues: [],
  formValuesTemplate: '',
  actions: [],
  disabled: false,
};

CprText.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  formValues: PropTypes.array,
  formValuesTemplate: PropTypes.string,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  columns: PropTypes.string.isRequired,
  mobileColumns: PropTypes.string,
  label: PropTypes.string,
  desc: PropTypes.string,
  maxLength: PropTypes.number,
  endFocus: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  isLoading: PropTypes.string,
  values: PropTypes.object.isRequired,
  actions: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  setValues: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  translations: PropTypes.object,
  disabled: PropTypes.bool,
};
